import { Action, Dispatch } from "redux";
import { PAGE_TYPE } from "../pages/page.types";
import fetchContentByRoute from "../helpers/fetchContentByRoute";
import isBrowserContext from "helpers/isBrowserContext";

export const UPDATE_PAGE = "UPDATE_PAGE";
export const SET_LOCALE = "SET_LOCALE";

export interface UpdatePageAction extends Action {
    type: typeof UPDATE_PAGE;
    content: PAGE_TYPE;
    statusCode: number;
    redirectUrl?: string;
    [key: string]: any;
}

export interface SetLocaleAction extends Action {
    type: typeof SET_LOCALE;
    languageUrl: string;
    languageId: string;
    [key: string]: any;
}

export const thunkSetLocale =
    (languageUrl: string, languageId: string) =>
    async (dispatch: Dispatch): Promise<void> => {
        const action: SetLocaleAction = {
            type: SET_LOCALE,
            languageUrl: languageUrl,
            languageId: languageId,
        };

        dispatch(action);
    };

export const thunkUpdatePage = (url: string, historyHook?: any, locationHook?: any) => {
    return async (dispatch: Dispatch): Promise<void> => {
        try {
            if (!url) {
                throw new Error("URL is required");
            }

            const pageResponse = await fetchContentByRoute(url);

            if ((pageResponse.result?.umbracoRedirect || pageResponse.redirectUrl) && isBrowserContext()) {
                // TODO: Test if working
                window.location.href = pageResponse.result?.umbracoRedirect ?? pageResponse.redirectUrl ?? "/";
            } else if (typeof pageResponse.result !== "undefined") {
                const action: UpdatePageAction = {
                    type: UPDATE_PAGE,
                    content: pageResponse.result,
                    statusCode: pageResponse.statusCode,
                };

                if (historyHook && locationHook) {
                    // React Router v6: navigate(to, { replace, state })
                    const path = locationHook.pathname + locationHook.search + locationHook.hash;
                    historyHook(path, {
                        replace: true,
                        state: {
                            ...locationHook?.state,
                            page: pageResponse.result,
                        },
                    });
                }

                dispatch(action);
            }
        } catch (error) {
            // Log the error for debugging
            if (isBrowserContext()) {
                console.error("Error loading page:", error);
            }

            // TODO: Retry loading the page every 2 seconds

            const action: UpdatePageAction = {
                type: UPDATE_PAGE,
                content: {
                    _contentType: "errorPage",
                    _name: "500 - An error occured",
                    _url: url,
                },
                statusCode: 500,
            };

            dispatch(action);
        }
    };
};

export type PageAction = UpdatePageAction | SetLocaleAction;
